import filterLinebreaksBr from 'common/filters/filterLinebreaksBr'

/**
 * Текст акции для `v-html`: переносы строк становятся `<br>`.
 */
export default function getPromotionTextHtml(text: string): string {
  if (!text) {
    return ''
  }

  return filterLinebreaksBr(text)
}
